;(function() {
  'use strict'

  angular.module('core.contentGroupsList', [])
})()
